import { pipeReducers, partialPayload } from '@ardoq/common-helpers';
import { ComponentHierarchyState } from '../../componentHierarchyTypes';
import { navigatorTreeOperations } from '../../reducers/navigatorTreeOperations';
import { NavigatorLayoutState } from '../../types';

export const enhancedScopeDataStreamReducer = (
  state: NavigatorLayoutState,
  { navigatorInterface, context, externalFilter }: ComponentHierarchyState
) => {
  return pipeReducers(
    state,
    partialPayload(navigatorTreeOperations.setExternalFilter, externalFilter),
    partialPayload(
      navigatorTreeOperations.setNavigatorViewInterface,
      navigatorInterface
    ),
    partialPayload(navigatorTreeOperations.setSort, context.sort),
    partialPayload(navigatorTreeOperations.resetTree, context)
  );
};
